// dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AirlineMultiSelect from '../../../src/components/lib/AirlineMultiSelect';
import AirportMultiSelect from '../../../src/components/lib/AirportMultiSelect';
import CountryMultiSelect from '../../../src/components/lib/CountryMultiSelect';
import RegionMultiSelect from '../../../src/components/lib/RegionMultiSelect';

const selectFieldComponents = {
  airlines: AirlineMultiSelect,
  arrivalAirports: AirportMultiSelect,
  departureAirports: AirportMultiSelect,
  arrivalCountries: CountryMultiSelect,
  departureCountries: CountryMultiSelect,
  arrivalRegions: RegionMultiSelect,
  departureRegions: RegionMultiSelect,
};

export default class MultiSelect extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    titleLabel: PropTypes.string,
    titleLabelClass: PropTypes.string,
    params: PropTypes.object,
    fieldType: PropTypes.string,
    airlines: PropTypes.array,
    arrivalAirports: PropTypes.array,
    departureAirports: PropTypes.array,
    arrivalCountries: PropTypes.array,
    departureCountries: PropTypes.array,
    arrivalRegions: PropTypes.array,
    departureRegions: PropTypes.array,
    secondary: PropTypes.bool,
  };

  renderSearchField = () => {
    const { fieldType } = this.props;

    if (!fieldType) {
      return (<div>error...</div>);
    }

    const { dispatch, [fieldType]: value } = this.props;
    const ChildComponent = selectFieldComponents[fieldType];
    return (
      <ChildComponent
        dispatch={dispatch}
        identifier={fieldType}
        value={value}
      />
    );
  }

  render() {
    const { titleLabel, titleLabelClass, fieldType } = this.props;

    return (
      <div className='multi-select-container'>
        <p id={`${fieldType}-${this.props.params && this.props.params.exportType}`} className={`multi-select-title-label ${titleLabelClass}`}>{titleLabel}</p>
        <div className='row'>
          <div className='col-xs-12'>
            <div className='filter-label-container'>
              <div className={`filter-label multi-select${this.props.secondary ? ' secondaryLabel' : ''}`}>
                {this.renderSearchField()}
              </div>
            </div>
          </div>
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./shared/components/MultiSelect/MultiSelect.js